<div class="banner" [class.short]="short">
  <em  class="mdi mdi-clock mdi-16px pr-1" aria-hidden="true"></em>
<span class="text">{{message}}</span>

</div>
